// src/components/Home.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/bg.png";
import logo from "../assets/logo.png";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

const Home = () => {
    const navigate = useNavigate();
    const { login, register, isAuthenticated, user, getToken } = useKindeAuth();

    useEffect(() => {
        const handleAuth = async () => {
            if (isAuthenticated && user) {
                const accessToken = await getToken();
                // console.log("accessToken:", accessToken);
                if (accessToken) {
                    // Save user data and token to localStorage.
                    localStorage.setItem("username", user.givenName);
                    localStorage.setItem("email", user.email);
                    localStorage.setItem("accessToken", accessToken);

                    window.dispatchEvent(new Event("authUpdated"));

                    // Redirect to dashboard.
                    navigate("/dashboard");
                }
            }
        };

        handleAuth();
    }, [isAuthenticated, user, getToken, navigate]);

    return (
        <div
            className="min-h-[100svh] flex items-center justify-center bg-gray-100 px-4 bg-cover bg-center"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="w-full max-w-xl">
                <div className="overflow-hidden rounded-2xl border border-gray-200/70 bg-black/70 backdrop-blur-sm shadow-[0_18px_45px_rgba(15,23,42,0.25)]">
                    <div className="p-6 sm:p-8 space-y-8">
                        {/* Logo + app name */}
                        <div className="flex items-center gap-3">
                            <div className="flex h-10 w-10 items-center justify-center rounded bg-blue-600">
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className="h-8 w-8 rounded bg-white/10 p-0.5"
                                />
                            </div>
                            <div className="flex flex-col text-left">
                                <span className="text-sm font-semibold uppercase tracking-wide text-blue-200">
                                    Kaizen
                                </span>
                                <span className="text-xs text-gray-300">
                                    Sign in to access your dashboard
                                </span>
                            </div>
                        </div>

                        {/* Title + description */}
                        <div className="space-y-2 text-left">
                            <h1 className="text-2xl sm:text-3xl font-semibold text-white">
                                Welcome to Kaizen
                            </h1>
                            <p className="text-sm sm:text-base text-gray-200">
                                Create an account or sign in to continue.
                            </p>
                        </div>

                        {/* Call to action */}
                        <div className="space-y-3">
                            <div className="flex flex-col sm:flex-row gap-3">
                                <button
                                    onClick={() => register()}
                                    type="button"
                                    className="group relative inline-flex h-11 flex-1 items-center justify-center gap-2 overflow-hidden rounded-xl bg-blue-600 px-5 text-md font-semibold text-white shadow-sm ring-1 ring-white/10 transition hover:bg-blue-500 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/70 active:translate-y-px"
                                >
                                    <span className="absolute inset-0 opacity-0 transition-opacity group-hover:opacity-100 bg-[radial-gradient(120px_circle_at_50%_0%,rgba(255,255,255,0.18),transparent_60%)]" />
                                    <span className="relative">Sign up</span>
                                </button>

                                <button
                                    onClick={() => login()}
                                    type="button"
                                    className="group relative inline-flex h-11 flex-1 items-center justify-center gap-2 overflow-hidden rounded-xl bg-yellow-500 px-5 text-md font-semibold text-slate-900 shadow-sm ring-1 ring-black/5 transition hover:bg-yellow-400 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/70 active:translate-y-px"
                                >
                                    <span className="absolute inset-0 opacity-0 transition-opacity group-hover:opacity-100 bg-[radial-gradient(120px_circle_at_50%_0%,rgba(255,255,255,0.35),transparent_60%)]" />
                                    <span className="relative">Sign in</span>
                                </button>
                            </div>

                            <p className="text-xs text-gray-300 text-center">
                                Secure authentication powered by Kinde.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
